import { render } from "./AddUserForm.vue?vue&type=template&id=090d4b8e&scoped=true"
import script from "./AddUserForm.vue?vue&type=script&lang=js"
export * from "./AddUserForm.vue?vue&type=script&lang=js"

import "./AddUserForm.vue?vue&type=style&index=0&id=090d4b8e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-090d4b8e"

export default script